import { useDispatch, useSelector } from "react-redux";
import { downloadAnnualDateExcel } from "../thunks/downloadAnnualDateReportExcel";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";

export const useAnnualDateExcelDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.annualTrade.downloadReportFetchState
  );

  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadAnnualDateExcel()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
